module.exports = __webpack_public_path__ + "static/img/5g (1).ce0f2e9d.png";